<ng-template #reportContent>
  <div class="modal-header">
    <h5 class="modal-title">Generate Course Report</h5>
  </div>
  <hr>
    <div class="h-30"></div>
    <div class="modal-body">
      <div class="report-body">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Date range</mat-label>
          <mat-select placeholder="Select Dates" name="daterange" [(value)]="drpDateRangeValue" (valueChange)="ondrpDateRangeChange()">
            <mat-option value="1">Last 30 days</mat-option>
            <mat-option value="2">Last 3 months</mat-option>
            <mat-option value="3">Last year</mat-option>
            <mat-option value="4">Custom</mat-option>
          </mat-select>
        </mat-form-field>
        <div class="custom-dates" [hidden]="hideCustomeDate">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Start Date</mat-label>
            <input matInput [matDatepicker]="dp4" [(ngModel)]="query.StartDate" name="startdate"
              placeholder="DD/MM/YYYY" required>
              <mat-datepicker-toggle matIconSuffix [for]="dp4"></mat-datepicker-toggle>
              <mat-datepicker #dp4></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>End Date</mat-label>
              <input matInput [matDatepicker]="dp5" [(ngModel)]="query.EndDate" name="enddate" placeholder="DD/MM/YYYY"
                required>
                <mat-datepicker-toggle matIconSuffix [for]="dp5"></mat-datepicker-toggle>
                <mat-datepicker #dp5></mat-datepicker>
              </mat-form-field>
            </div>
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Program</mat-label>
              <mat-select placeholder="All Programs" name="filterprogram" [(ngModel)]="query.ProgramId">
                <mat-option value="0">All Programs</mat-option>
                @for (p of programs; track p) {
                  <mat-option [value]="p.id">{{p.programName}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-buttons">
            <div class="filterButtons float-left">
              <button class="submit-form-button" (click)="generateReport()" #submitButton [disabled]="isLoading">
                @if (!isLoading) {
                  Generate Extract
                } @else {
                  <div class="loader"><img src="/assets/loader.gif" class="login-loader w-100"></div>
                }
              </button>
              <button type="button" class="submit-form-button cancel-button" (click)="closeModal()">Cancel</button>
            </div>
          </div>
        </div>
      </ng-template>

      @if (isPageMode) {
        <app-topnav [pageName]="pageName"></app-topnav>
        <div class="container">
          <div class="generate-report-modal generate-report-modal--page">
            <ng-container *ngTemplateOutlet="reportContent"></ng-container>
          </div>
        </div>
        <app-footer></app-footer>
      }

      @if (!isPageMode) {
        <div class="generate-report-modal">
          <ng-container *ngTemplateOutlet="reportContent"></ng-container>
        </div>
      }
